import React from 'react';
import { Select } from 'src/ui/Select';
import { Button } from 'src/ui/Button';
import { Icon } from 'src/ui/Icon';

import { useSelector } from 'react-redux';
import {
  selectInterview,
  selectSortedInterviews,
} from 'src/store/interviewSlice';

export interface InterviewCollectSelectorProps {
  id: number;
  field?: string;
  onChange: (id: number, field?: string) => void;
  language?: string;
  onDelete: () => void;
}

const InterviewCollectSelector = ({
  id,
  onChange,
  field,
  language = 'cn',
  onDelete,
}: InterviewCollectSelectorProps) => {
  const sortedInterviews = useSelector(selectSortedInterviews);
  const interview = useSelector(selectInterview(id));
  return (
    <div className="col" style={{ gap: 8 }}>
      <div className="row" style={{ gap: 16, alignItems: 'flex-end' }}>
        <div className="col" style={{ gap: 4, flex: 1 }}>
          <label
            style={{
              fontSize: 'var(--fs-sm)',
              fontWeight: 500,
              color: 'var(--text)',
            }}
          >
            Interview
          </label>
          <Select
            value={id}
            onChange={(e) => onChange(Number(e.target.value), field)}
          >
            <option>Select</option>
            {sortedInterviews.map((interview) => (
              <option key={interview.id} value={interview.id}>
                {interview.name}
              </option>
            ))}
          </Select>
        </div>
        <Button
          variant="danger"
          iconOnly
          aria-label="Delete"
          onClick={onDelete}
        >
          <Icon name="trash" size={16} />
        </Button>
      </div>
      <div className="col" style={{ gap: 4 }}>
        <label
          style={{
            fontSize: 'var(--fs-sm)',
            fontWeight: 500,
            color: 'var(--text)',
          }}
        >
          Collect
        </label>
        <Select value={field} onChange={(e) => onChange(id, e.target.value)}>
          <option>Select</option>
          {interview?.collect.map(([f, descriptions]) => (
            <option key={f} value={f}>
              {descriptions?.[language]}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default InterviewCollectSelector;
